import { jsxs, jsx } from "react/jsx-runtime";
const IconCodeBranchSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M11.562 4.04a2 2 0 0 0-.767 3.847 1.333 1.333 0 0 1-1.233.82H6.895a2.6 2.6 0 0 0-1.333.373V5.253a2 2 0 1 0-1.334 0v5.574a2 2 0 1 0 1.44.033 1.333 1.333 0 0 1 1.227-.82h2.667a2.667 2.667 0 0 0 2.607-2.107 2 2 0 0 0-.607-3.893ZM4.895 2.707a.667.667 0 1 1 0 1.333.667.667 0 0 1 0-1.333Zm0 10.666a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334Zm6.667-6.666a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334Z" })
    ]
  }
);
export {
  IconCodeBranchSvg
};
